import Cookies from 'js-cookie';

export default () => {
    return {
        open: true,

        init() {
            if (Cookies.get('cookie-consent')) {
                this.open = false;
            } else {
                gsap.from(this.$refs.container, { duration: 0.6, yPercent: 101, delay: 2, ease: 'circ.inOut' });
            }
        },

        accept() {
            Cookies.set('cookie-consent', 'true', { expires: 60 });

            gsap.to(this.$refs.container, {
                duration: 0.5,
                yPercent: 101,
                ease: 'circ.inOut',
                onComplete: () => {
                    this.open = false;
                }
            });
        }
    };
};
